import { Skeleton } from '@/components/ui/skeleton';

/**
 * Content-area Suspense fallback for the persistent admin shell. Renders where
 * page content goes — a page-head bar plus a few card/table rows — so the first
 * visit to a lazily-loaded route shows a shaped placeholder inside the (already
 * mounted) sidebar/topbar instead of blanking the whole screen.
 *
 * AdminLayout wraps the content area in `p-4 lg:p-6`, so this deliberately omits
 * its own outer padding to stay aligned with the real content it stands in for.
 */
export function ContentSkeleton() {
  return (
    <div className="space-y-6" aria-hidden="true">
      {/* Page head: title + subtitle */}
      <div className="space-y-2.5">
        <Skeleton className="h-7 w-52" />
        <Skeleton className="h-4 w-72 max-w-full" />
      </div>

      {/* Stat / KPI tiles */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <Skeleton className="h-24 rounded-[15px]" />
        <Skeleton className="h-24 rounded-[15px]" />
        <Skeleton className="h-24 rounded-[15px]" />
      </div>

      {/* Card / table rows */}
      <div className="space-y-3">
        <Skeleton className="h-11 w-full rounded-xl" />
        <Skeleton className="h-11 w-full rounded-xl" />
        <Skeleton className="h-11 w-full rounded-xl" />
        <Skeleton className="h-11 w-full rounded-xl" />
      </div>
    </div>
  );
}
